// extracted by mini-css-extract-plugin
export default {"root":"IRBZBl","spinner-rotate":"nNatgL","spinnerRotate":"nNatgL","circle":"huFRn6","spinner-dash":"doAgnT","spinnerDash":"doAgnT","static":"VYbHJq"};